import { create } from "zustand";

export type DocumentType = "invoice" | "fee" | "credit-note";
export type DocumentTypeFilter = "all" | DocumentType;

export type PayoutStoreState = {
  documentType: DocumentTypeFilter;
  setDocumentType: (documentType: DocumentTypeFilter) => void;
  reset: () => void;
  setState: (state: PayoutStoreState) => void;
};

export const usePayoutStore = create<PayoutStoreState>((set) => ({
  documentType: "all",
  setDocumentType: (documentType) => set({ documentType }),
  reset: () => set({ documentType: "all" }),
  setState: (state) => set(state),
}));
